/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createProductTransferRequests } from '../fn/product-transfers/create-product-transfer-requests';
import { CreateProductTransferRequests$Params } from '../fn/product-transfers/create-product-transfer-requests';
import { getProductTransferRequests } from '../fn/product-transfers/get-product-transfer-requests';
import { GetProductTransferRequests$Params } from '../fn/product-transfers/get-product-transfer-requests';
import { PageProductTransferAdminPageResponse } from '../models/page-product-transfer-admin-page-response';
import { updateProductTransferStatus } from '../fn/product-transfers/update-product-transfer-status';
import { UpdateProductTransferStatus$Params } from '../fn/product-transfers/update-product-transfer-status';


/**
 * Product transfer request endpoints. POST requires PRODUCT_ADMIN. GET and PUT /status require EASYLOT_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ProductTransfersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateProductTransferStatus()` */
  static readonly UpdateProductTransferStatusPath = '/products/transfers/status';

  /**
   * Updates the status of the product transfers by admin.
   *
   * Updates the status of product transfers based on the provided list of product ids and a status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductTransferStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductTransferStatus$Response(params: UpdateProductTransferStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateProductTransferStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the status of the product transfers by admin.
   *
   * Updates the status of product transfers based on the provided list of product ids and a status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProductTransferStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductTransferStatus(params: UpdateProductTransferStatus$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateProductTransferStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getProductTransferRequests()` */
  static readonly GetProductTransferRequestsPath = '/products/transfers';

  /**
   * List the product transfers for administrators.
   *
   * List the product transfers for administrators in pageable format with filters
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductTransferRequests()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductTransferRequests$Response(params?: GetProductTransferRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductTransferAdminPageResponse>> {
    const obs = getProductTransferRequests(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List the product transfers for administrators.
   *
   * List the product transfers for administrators in pageable format with filters
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductTransferRequests$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductTransferRequests(params?: GetProductTransferRequests$Params, context?: HttpContext): Observable<PageProductTransferAdminPageResponse> {
    const resp = this.getProductTransferRequests$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductTransferAdminPageResponse>): PageProductTransferAdminPageResponse => r.body)
    );
  }

  /** Path part for operation `createProductTransferRequests()` */
  static readonly CreateProductTransferRequestsPath = '/products/transfers';

  /**
   * Create product transfers.
   *
   * Create product transfers from specified packagingUnits
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductTransferRequests()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProductTransferRequests$Response(params: CreateProductTransferRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = createProductTransferRequests(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create product transfers.
   *
   * Create product transfers from specified packagingUnits
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProductTransferRequests$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProductTransferRequests(params: CreateProductTransferRequests$Params, context?: HttpContext): Observable<void> {
    const resp = this.createProductTransferRequests$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
